import { createAsyncThunk } from "@reduxjs/toolkit";
import { setBudgetDetailsDrawerBudgetId } from "@/store/budgets/budgetsSlice";
import { invalidateBudgetDetailsCacheThunk } from "@/store/budgets/thunks/drawer/invalidateBudgetDetailsCacheThunk";
import { invalidateBudgetDetailsAccumulatedCostCacheThunk } from "@/store/budgets/thunks/drawer/invalidateBudgetDetailsAccumulatedCostCacheThunk";

export const closeBudgetDetailsDrawerThunk = createAsyncThunk(
  "budgets/closeBudgetDetailsDrawer",
  (_, { dispatch }) => {
    dispatch(invalidateBudgetDetailsAccumulatedCostCacheThunk());
    dispatch(invalidateBudgetDetailsCacheThunk());
    dispatch(setBudgetDetailsDrawerBudgetId(null));
  },
);
